import { render, staticRenderFns } from "./IndustryValue.vue?vue&type=template&id=55ad8999&scoped=true&"
import script from "./IndustryValue.vue?vue&type=script&lang=js&"
export * from "./IndustryValue.vue?vue&type=script&lang=js&"
import style0 from "./IndustryValue.vue?vue&type=style&index=0&id=55ad8999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad8999",
  null
  
)

export default component.exports